import {
  Image, ListItem,
} from '@domain-group/suit-theme'
import useImage from '@hooks/useImage'

interface ImageListItemProps {
  image: {
    thumb_url: string,
  },
}
const ImageListItem = (props: ImageListItemProps) => {
  const { image, image: { thumb_url } } = props

  const imagePayload = useImage(image)
  const {
    callbacks: {
      createOrEditImage,
    },
  } = imagePayload

  return (
    <ListItem
      onClick={() => createOrEditImage()}
    >
      <Image
        backgroundSize="cover"
        borderRadius={5}
        boxProps={{ border: '1px solid', borderColor: 'lineColor' }}
        url={thumb_url}
      />
    </ListItem>
  )
}

export default ImageListItem
